export default __webpack_public_path__ + "static/media/bun-pho.f040c013.jpg";